import Vue from "vue";
import router from "@/plugins/router";
import store from "@/plugins/store";
import Notifications from "vue-notification";
import VModal from "vue-js-modal";
import "@/tailwind.css";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import "@/utils/fontawesome.js";
import "@/plugins/designSystem.js";
import GridLayout from "@/components/GridLayout";
import { Kalendar } from "@/components/kalendar-vue";
import VCalendar from "v-calendar";
import PortalVue from "portal-vue";

Vue.use(PortalVue);
Vue.component("FontAwesomeIcon", FontAwesomeIcon);
Vue.component("GridLayout", GridLayout);
Vue.component("Kalendar", Kalendar);

Vue.config.productionTip = false;
Vue.config.mockingBird = false;

Vue.use(Notifications);
Vue.use(VModal);
Vue.use(VCalendar, {
  componentPrefix: "vc" // Use <vc-calendar /> instead of <v-calendar />
});

const App = () => ({
  component: import(/* webpackChunkName: "main-app" */ "@/App.vue"),
  delay: 0
});

export const appInstance = new Vue({
  router,

  store,
  render: h => h(App)
}).$mount("#app");

export default appInstance;
